/**
 * @module kiosk attributes
 *
 * Used by companies as options that can be used when identifying onself in a
 * kiosk survey.
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { companyActions } from '~/behaviors/actions/company.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeKioskAttributes = (state, action) => {
  const kioskAttributes = action?.payload?.entities?.kioskAttributes || {};

  Object.values(kioskAttributes).forEach((attr) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[attr.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[attr.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...attr,
    };
  });
};

const kioskAttributes = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(companyActions.fetchCompanyKioskSettings.fulfilled, mergeKioskAttributes);
  builder.addCase(companyActions.updateCompanyKioskSettings.fulfilled, mergeKioskAttributes);
});

export default kioskAttributes;
